import POST_COMPONENT_TYPE from '../postComponentType';
import BloodLipidsHero from '../../../assets/images/blood-lipids-hero-section.png';
import { IconType } from '../../../components/BannerWithList';
import { BackgroundColor } from '../../../components/BannerWithTextAndDescription';

const bloodLipids = {
  key: 'blood-lipids',
  sectionList: [
    {
      type: POST_COMPONENT_TYPE.title,
      text: 'learnMoreContent.blood-lipids.name'
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextBox,
      image: BloodLipidsHero,
      text: 'learnMoreContent.blood-lipids.banner.text'
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.blood-lipids.importance.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          title: 'learnMoreContent.blood-lipids.importance.listGroup1.title',
          items: [
            {
              text:
                'learnMoreContent.blood-lipids.importance.listGroup1.listItem1',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.blood-lipids.importance.listGroup1.listItem2',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.blood-lipids.importance.listGroup1.listItem3',
              type: 'text'
            }
          ]
        },
        {
          title: 'learnMoreContent.blood-lipids.importance.listGroup2.title',
          items: [
            {
              text:
                'learnMoreContent.blood-lipids.importance.listGroup2.listItem1',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.blood-lipids.importance.listGroup2.listItem2',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.blood-lipids.importance.listGroup2.listItem3',
              type: 'text'
            }
          ]
        }
      ]
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.blood-lipids.overweight.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.blood-lipids.overweight.listItem1',
              type: 'text'
            },
            {
              text: 'learnMoreContent.blood-lipids.overweight.listItem2',
              type: 'text'
            },
            {
              text: 'learnMoreContent.blood-lipids.overweight.listItem3',
              type: 'text'
            }
          ]
        }
      ]
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextAndDescription,
      title: 'learnMoreContent.blood-lipids.measured.title',
      description: {
        text: 'learnMoreContent.blood-lipids.measured.description',
        type: 'text'
      },
      backgroundColor: BackgroundColor.GREEN
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.blood-lipids.improvement.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          title: 'learnMoreContent.blood-lipids.improvement.listGroup1.title',
          items: [
            {
              text:
                'learnMoreContent.blood-lipids.improvement.listGroup1.listItem1',
              type: 'text',
              subItems: [
                {
                  text:
                    'learnMoreContent.blood-lipids.improvement.listGroup1.listItem1.subItem1',
                  type: 'text'
                },
                {
                  text:
                    'learnMoreContent.blood-lipids.improvement.listGroup1.listItem1.subItem2',
                  type: 'text'
                }
              ]
            },
            {
              text:
                'learnMoreContent.blood-lipids.improvement.listGroup1.listItem2',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.blood-lipids.improvement.listGroup1.listItem3',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.blood-lipids.improvement.listGroup1.listItem4',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.blood-lipids.improvement.listGroup1.listItem5',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.blood-lipids.improvement.listGroup1.listItem6',
              type: 'text'
            }
          ]
        }
      ]
    }
  ]
};

export default bloodLipids;
